module.exports = __webpack_public_path__ + "6396558fdcae1f3f3091c79a7a00dc91.svg";